import React, { useState, useEffect } from "react";
import { Modal, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

const AuthModal = ({
  show,
  onHide,
  mode: initialMode = "login",
  onLogin,
  onSignup,
  onReset,
  errors,
  loading,
  success,
  setSuccess, // Add setSuccess prop
}) => {
  const [currentMode, setCurrentMode] = useState(initialMode);
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    bio: "",
    role: "Role",
    email: "",
    password1: "",
    password2: "",
  });
  const [resetEmail, setResetEmail] = useState("");

  // Reset mode and inputs when modal closes
  useEffect(() => {
    if (!show) {
      setCurrentMode("login");
      setLoginData({ email: "", password: "" });
      setSignupData({
        firstName: "",
        lastName: "",
        bio: "",
        role: "Role",
        email: "",
        password1: "",
        password2: "",
      });
      setResetEmail("");
      setSuccess(false); // Reset success state
    }
  }, [show, setSuccess]);

  const handleModeChange = (newMode) => {
    setCurrentMode(newMode);
    if (errors) errors = {};
    setSuccess(false); // Reset success state
  };

  return (
    <>
      {/* Login Modal */}
      <Modal
        className="fade modal-wrapper auth-modal"
        show={show && currentMode === "login"}
        onHide={onHide}
        centered
      >
        <h2 className="title">Login Your Account</h2>
        {Object.keys(errors).length > 0 && (
          <div style={{ color: "red", marginBottom: 20 }}>
            <ul>
              {Object.entries(errors).map(([field, messages]) =>
                messages.map((message, index) => (
                  <li key={`${field}-${index}`} style={{ fontSize: 14 }}>
                    <strong>{field.replace("_", " ")}:</strong> {message}
                  </li>
                ))
              )}
            </ul>
          </div>
        )}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onLogin(loginData);
          }}
        >
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="Email Address"
              value={loginData.email}
              onChange={(e) =>
                setLoginData({ ...loginData, email: e.target.value })
              }
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={loginData.password}
              onChange={(e) =>
                setLoginData({ ...loginData, password: e.target.value })
              }
            />
            <div className="reset-password">
              <Link
                to={"#"}
                className="btn-link collapsed"
                onClick={() => handleModeChange("reset")}
              >
                Reset password?
              </Link>
            </div>
          </div>
          <div className="form-group">
            <button
              disabled={loading}
              type="submit"
              className="btn btn-outline-primary btn-block"
            >
              {loading ? "Loading ..." : "Login"}
            </button>
          </div>
          <div className="sign-text">
            <span>
              Don't have a Crowdfunding account?
              <Link
                to={"#"}
                className="btn-link collapsed"
                onClick={() => handleModeChange("signup")}
              >
                {" "}
                Sign up
              </Link>
            </span>
          </div>
        </form>
      </Modal>

      {/* Signup Modal */}
      <Modal
        className="fade modal-wrapper auth-modal"
        show={show && currentMode === "signup"}
        // show={true}
        onHide={onHide}
        centered
      >
        {success ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ color: "green", fontSize: 40 }}>
              <FaCheckCircle />
            </div>
            <p style={{ marginBottom: 0, color: "black" }}>
              Thanks for your registration!
            </p>
            {/* <small>We have sent to you a verification email</small> */}
            <small>You can now log in to your account</small>

            <button
              type="button"
              className="btn btn-outline-primary btn-block mt-4"
              onClick={onHide}
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <h2 className="title">Sign Up Your Account</h2>
            {Object.keys(errors).length > 0 && (
              <div style={{ color: "red", marginBottom: 20 }}>
                <ul>
                  {Object.entries(errors).map(([field, messages]) =>
                    messages.map((message, index) => (
                      <li key={`${field}-${index}`} style={{ fontSize: 14 }}>
                        <strong>{field.replace("_", " ")}:</strong> {message}
                      </li>
                    ))
                  )}
                </ul>
              </div>
            )}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                onSignup(signupData);
              }}
            >
              <div style={{ display: "flex", gap: 8 }}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First name"
                    value={signupData.firstName}
                    onChange={(e) =>
                      setSignupData({
                        ...signupData,
                        firstName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last name"
                    value={signupData.lastName}
                    onChange={(e) =>
                      setSignupData({
                        ...signupData,
                        lastName: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="form-group">
                <textarea
                  rows={3}
                  className="form-control"
                  placeholder="Bio"
                  value={signupData.bio}
                  onChange={(e) =>
                    setSignupData({ ...signupData, bio: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <Dropdown className="select-drop">
                  <Dropdown.Toggle as="div" className="i-false select-drop-btn">
                    <span style={{ textTransform: "capitalize" }}>
                      {signupData.role}
                    </span>
                    <i className="fa-regular fa-angle-down"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() =>
                        setSignupData({ ...signupData, role: "founder" })
                      }
                    >
                      Founder
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        setSignupData({ ...signupData, role: "backer" })
                      }
                    >
                      Backer
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <hr />
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email Address"
                  value={signupData.email}
                  onChange={(e) =>
                    setSignupData({ ...signupData, email: e.target.value })
                  }
                />
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    value={signupData.password1}
                    onChange={(e) =>
                      setSignupData({
                        ...signupData,
                        password1: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password Confirmation"
                    value={signupData.password2}
                    onChange={(e) =>
                      setSignupData({
                        ...signupData,
                        password2: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="form-group">
                <button
                  disabled={loading}
                  type="submit"
                  className="btn btn-outline-primary btn-block"
                >
                  {loading ? "Loading ..." : "Sign Up"}
                </button>
              </div>
              <div className="sign-text">
                <span>
                  Already have an account?{" "}
                  <Link
                    to={"#"}
                    className="btn-link collapsed"
                    onClick={() => handleModeChange("login")}
                  >
                    Login
                  </Link>
                </span>
              </div>
            </form>
          </>
        )}
      </Modal>

      {/* Reset Password Modal */}
      <Modal
        className="fade modal-wrapper auth-modal"
        show={show && currentMode === "reset"}
        onHide={onHide}
        centered
      >
        <div className="reset-password" id="reset-password">
          <h2 className="title">Reset password?</h2>
          {errors?.reset && errors.reset.length > 0 && (
            <div style={{ color: "red", marginBottom: 20 }}>
              <ul>
                {errors.reset.map((message, index) => (
                  <li key={index} style={{ fontSize: 14 }}>
                    {message}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onReset(resetEmail);
            }}
          >
            <div className="form-group password-icon-bx">
              <i className="fa fa-lock"></i>
              <p>
                Enter your email address associated with your account, and we'll
                email you a link to reset your password...
              </p>
            </div>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                placeholder="Enter email address"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-outline-primary btn-block"
              >
                Send reset link
              </button>
            </div>
            <Link
              to={"#"}
              className="sign-text d-block"
              onClick={() => handleModeChange("login")}
            >
              Back
            </Link>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AuthModal;
